export default __webpack_public_path__ + "static/media/photo--lg--29.5c60d9dd.jpg";